export const formatNumberToTwoDecimals = (value: string | number): number => {
  if (!value) return 0
  const numValue = typeof value === 'string' ? parseFloat(value) : value
  return Number(numValue.toFixed(2))
}

export const calculatePercentage = (value: number, comparedValue: number): number => {
  if (!value || !comparedValue) return 0
  return ((value - comparedValue) / comparedValue) * 100
}

export const percentageWithFixedDecmials = (value: number, comparedValue: number): number => {
  return formatNumberToTwoDecimals(calculatePercentage(value, comparedValue))
}

export const formatINRShort = (value: number): string => {
  if (value >= 1e7) {
    // Crores
    return `${(value / 1e7).toFixed(value / 1e7 < 10 ? 2 : 1)}cr`
  } else if (value >= 1e5) {
    // Lakhs
    return `${(value / 1e5).toFixed(value / 1e5 < 10 ? 2 : 1)}L`
  } else if (value >= 1e3) {
    // Thousands
    return `${(value / 1e3).toFixed(value / 1e3 < 10 ? 2 : 1)}k`
  }
  return value.toString()
}

/** Net sales for prose, e.g. "1.25L" — rounded to paise, then shortened. */
export const formatNetSalesShort = (value: number): string => formatINRShort(formatNumberToTwoDecimals(value))
